/**
 * Authorization Roles
 */
const authRoles = {
    admin: 'admin',
    user: 'user',
    onlyGuest: 'guest'
};

export default authRoles;
